import React, { useEffect, useRef, useState } from 'react';
import { Constants } from '../../constants';

type ResendOtpProps = {
  onClick: () => Promise<void>;
};

export const ResendOtp: React.FC<ResendOtpProps> = ({ onClick }) => {
  const resendOTPTimer = useRef<NodeJS.Timer>();
  const [resendOTPTimeRemaining, setResendOTPTimeRemaining] = useState<number>(Constants.RESEND_OTP_TIMER_IN_SECONDS);

  useEffect(() => {
    startResendOtpTimer();
    return () => {
      if (resendOTPTimer.current) {
        clearInterval(resendOTPTimer.current);
      }
    };
  }, []);

  const startResendOtpTimer = (): void => {
    if (resendOTPTimer.current) {
      clearInterval(resendOTPTimer.current);
    }
    setResendOTPTimeRemaining(Constants.RESEND_OTP_TIMER_IN_SECONDS);
    resendOTPTimer.current = setInterval(() => {
      setResendOTPTimeRemaining(remainingTime => {
        if (remainingTime === 1) {
          clearInterval(resendOTPTimer.current);
        }
        return remainingTime - 1;
      });
    }, 1000);
  };

  const onPress = async (): Promise<void> => {
    await onClick();
    startResendOtpTimer();
  };

  const canResendOTP = resendOTPTimeRemaining <= 0;

  return (
    <>
      {
        <div className="mb-3 d-flex justify-content-between">
          <span style={{ color: '#EC4D3E', fontSize: '12px' }}>Didn’t receive code ?</span>
          <div>
            {!canResendOTP && <span className="">{resendOTPTimeRemaining < 10 ? `00:0${resendOTPTimeRemaining}` : `00:${resendOTPTimeRemaining}`}</span>}
            <button className="send-again" disabled={!canResendOTP} onClick={onPress}>
              Resend
            </button>
          </div>
        </div>
      }
    </>
  );
};
